import React from 'react';

function Single(props) {
    return (
        <div>
            Single

        </div>
    );
}

export default Single;